import { InjectionToken } from '@angular/core';

export type AlgoliaConfig = {
	applicationId: string;
	apiKey: string;
};

export const ALGOLIA = new InjectionToken<AlgoliaConfig>('AlgoliaToken');
